export default "// Variables\n@images: \"../img\";\n\n// Usage\nbody {\n  color: #444;\n  background: url(\"@{images}/white-sand.png\");\n}"